/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import { mqTypes } from "../../Constants/enums";
import MediaQueryProvider from "./MediaQueryProvider";

// Default MEDIA_QUERY_TYPE is 'DEVICE_WIDTH'
// It's not supported for MEDIA_QUERY_TYPE = 'ALL'
const withMediaQuery = (WrappedComponent, mqType = mqTypes.DEVICE_WIDTH) =>
  class MediaQuery extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        mqState: null
      };
    }

    async componentDidMount() {
      this.mediaQueryProvider = await MediaQueryProvider.getInstance();
      this.mediaQueryProvider.addChangeListener(this.onMQStateChange, mqType);
      const currMQState = this.mediaQueryProvider.getBreakpoint(mqType);
      this.onMQStateChange(currMQState);
    }

    componentWillUnmount() {
      if (this.mediaQueryProvider) {
        this.mediaQueryProvider.removeChangeListener(
          this.onMQStateChange,
          mqType
        );
      }
    }

    onMQStateChange = async newMQState => {
      this.setState({
        mqState: newMQState
      });
    };

    render() {
      return <WrappedComponent {...this.props} {...this.state} />;
    }
  };

export default withMediaQuery;
